import { Action } from '@ngrx/store';

import { UserInterface } from '../../models';
import { ErgoTeamMemberInterface } from '../../models/ergo-team-member.model';

import { UserActionType } from '.';

export class DeleteUser implements Action {
  public readonly type: UserActionType = UserActionType.DeleteUser;

  constructor(public readonly payload: UserInterface) {}
}

export class DeleteUserCompleted implements Action {
  public readonly type: UserActionType = UserActionType.DeleteUserCompleted;

  constructor(public readonly payload: UserInterface) {}
}

export class DeleteUserFailed implements Action {
  public readonly type: UserActionType = UserActionType.DeleteUserFailed;

  constructor(public readonly payload: string) {}
}

export class RemoveErgoTeamMember implements Action {
  public readonly type: UserActionType = UserActionType.RemoveErgoTeamMember;

  constructor(public readonly payload: { teamMember: ErgoTeamMemberInterface, user: UserInterface }) {}
}

export class RemoveErgoTeamMemberCompleted implements Action {
  public readonly type: UserActionType = UserActionType.RemoveErgoTeamMemberCompleted;

  constructor(public readonly payload: ErgoTeamMemberInterface[]) {}
}

export class RemoveErgoTeamMemberFailed implements Action {
  public readonly type: UserActionType = UserActionType.RemoveErgoTeamMemberFailed;

  constructor(public readonly payload: UserInterface) {}
}
